// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Search = function Search(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M14.69 13.679l-3.25-3.25a5.791 5.791 0 10-1.315 1.17l3.322 3.322a.37.37 0 00.524 0l.719-.718a.371.371 0 000-.524zM4.137 9.595a4.026 4.026 0 115.8-.125l-.24.24a4.014 4.014 0 01-5.563-.114z"
    }))
  );
};

export default Search;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Search.js
// module id = 1050
// module chunks = 0